const CloseTask = ({ ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg xmlns="http://www.w3.org/2000/svg" width="10.849" height="10.849" viewBox="0 0 10.849 10.849" {...props}>
    <path
      fill="#333333"
      stroke="#333333"
      strokeWidth="0.6px"
      d="M7.027-24.3l-.7.7 4.3 4.3-4.3 4.3.7.7 4.3-4.3 4.3 4.3.7-.7-4.3-4.3 4.3-4.3-.7-.7-4.3 4.3z"
      transform="translate(-5.899 24.726)"
    />
  </svg>
);

export default CloseTask;
